// extracted by mini-css-extract-plugin
module.exports = {"bulletPointsWrapper":"UnorderedListSmall_bulletPointsWrapper__rGAjf"};